var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
// things like gatsby preload on card links appears to "change" the items array, so we instead
// reset the infinite scroll state if all IDs in the items array change 
export var getResetDepsOnId = function (items) {
  return [items.map(function (item) {
    return item.id;
  }).join(',')];
};
export var useInfiniteScrollArray = function (args) {
  var _a = args.all,
    all = _a === void 0 ? [] : _a,
    _b = args.itemsPerPage,
    itemsPerPage = _b === void 0 ? 0 : _b,
    _c = args.rootMargin,
    rootMargin = _c === void 0 ? '0px 0px 600px 0px' : _c;
  var _d = __read(React.useState(all.slice(0, itemsPerPage)), 2),
    items = _d[0],
    setItems = _d[1];
  var hasNextPage = all.length > items.length;
  var onLoadMore = function () {
    setItems(__spreadArray(__spreadArray([], __read(items), false), __read(all.slice(items.length, items.length + itemsPerPage)), false));
  };
  var resetDeps = args.getResetDeps ? args.getResetDeps() : getResetDepsOnId(all);
  // reset items if the source data changes (e.g. new search results, filtered results)
  React.useEffect(function () {
    setItems(all.slice(0, itemsPerPage));
  }, resetDeps);
  var loading = false;
  var _e = __read(useInfiniteScroll({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      rootMargin: rootMargin
    }), 2),
    sentryRef = _e[0],
    rootRef = _e[1].rootRef;
  // if itemsPerPage is 0, return all items instead
  if (itemsPerPage === 0) {
    return {
      items: all,
      sentryRef: sentryRef,
      hasNextPage: false
    };
  }
  return {
    items: items,
    sentryRef: sentryRef,
    rootRef: rootRef,
    hasNextPage: hasNextPage
  };
};